var _effectorFileName = "/src/page-content/payment/model.ts";
import { sample } from 'effector';
import { $servicesList, $teachersList, getServicesQuery, getTeachersQuery } from '@/shared/api/payment/api';
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';
export const paymentPage = declarePage({
  pageType: pagesPath.$url().pathname
});
sample({
  and: [{
    clock: paymentPage.open,
    target: [getTeachersQuery.refresh, getServicesQuery.refresh]
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 11,
      column: 0
    },
    sid: "2m6ngj"
  }
});
sample({
  and: [{
    clock: getServicesQuery.finished.success,
    fn: data => data.result.services ?? [],
    target: $servicesList
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 16,
      column: 0
    },
    sid: "2oxmfc"
  }
});
sample({
  and: [{
    clock: getTeachersQuery.finished.success,
    fn: data => data.result.teachers ?? [],
    target: $teachersList
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 22,
      column: 0
    },
    sid: "33s2g3"
  }
});